import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'views.CompaniesView.heading',
    defaultMessage: 'Nasze spółki'
  },
  legalForm: {
    id: 'views.CompaniesView.legalForm',
    defaultMessage: 'Forma prawna'
  },
  address: {
    id: 'views.CompaniesView.address',
    defaultMessage: 'Adres siedziby'
  },
  country: {
    id: 'views.CompaniesView.country',
    defaultMessage: 'Kraj rejestracji'
  },
  nip: {
    id: 'views.CompaniesView.nip',
    defaultMessage: 'NIP'
  },
  regon: {
    id: 'views.CompaniesView.regon',
    defaultMessage: 'REGON'
  },
  krs: {
    id: 'views.CompaniesView.krs',
    defaultMessage: 'KRS'
  },
  duns: {
    id: 'views.CompaniesView.duns',
    defaultMessage: 'DUNS'
  },
  amountOfCapital: {
    id: 'views.CompaniesView.amountOfCapital',
    defaultMessage: 'Wys. kapitału zakładowego'
  },
  shares: {
    id: 'views.CompaniesView.shares',
    defaultMessage: 'Udziały w spółce'
  },
  website: {
    id: 'views.CompaniesView.website',
    defaultMessage: 'Strona www'
  },
  subsidiaries: {
    id: 'views.CompaniesView.subsidiaries',
    defaultMessage: 'Spółki Zależne'
  },
  contact: {
    id: 'views.CompaniesView.contact',
    defaultMessage: 'Kontakt'
  }
});



// WEBPACK FOOTER //
// ./src/views/Companies/CompaniesView.intl.js